import { render } from "./HeroiconsSolidCubeTransparent.vue?vue&type=template&id=79fcb5c0"
const script = {}

import exportComponent from "C:\\wamp64\\www\\systems\\nova-erp-system\\nova\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"HeroiconsSolidCubeTransparent.vue"]])

export default __exports__